<template>
  <div class="bg-secondary-13 p-3 rounded">
    <icon-view
      class="icon-view__extended"
      icon="fas fa-flag"
      icon-background="#fff"
      icon-color="#FF7058"
      icon-size="12px"
      title="Información de la Determinación"
    />
    <div class="ml-5">
      <validation-observer ref="determinationFormRef" novalidate tag="form">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            :count-classes="['d-block', 'small-counter']"
            custom-error-msg="El comentario es requerido."
            :error="errors[0]"
            label="Comentario:"
            :maxlength="3000"
            show-char-count
          />
        </validation-provider>
      </validation-observer>
    </div>

    <div class="d-flex justify-content-end align-items-center">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="onCancelHandler"
      />
      <action-button
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="onSaveHandler"
      />
    </div>
  </div>
</template>

<script>
//Third Party
import { ValidationObserver, ValidationProvider } from 'vee-validate';

//Component Libs
import IconView from 'icon-view';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//constants
import { proposalRequestStatus } from '@/utils/constants/proposalRequestStatus.js';

//services
import {
  checkBusySsn,
  determineProposalRequest as _determineProposalRequest,
  resetDeterminationProposalRequest as _resetDeterminationProposalRequest,
} from '@/modules/proposalProcess/api.js';

export default {
  name: 'RequestDetermination',
  components: {
    ValidationObserver,
    ValidationProvider,
    IconView,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    determinationStatusId: {
      type: Number,
      required: true,
      validator(value) {
        return [
          proposalRequestStatus.Recommended,
          proposalRequestStatus.NotRecommended,
        ].includes(value);
      },
    },
    proposalRequestId: {
      type: Number,
      required: true,
    },
    proposalRequestNumber: {
      type: String,
      default: '',
    },
    isForResetDetermination: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    model: {
      comment: null,
    },
  }),
  computed: {
    actionDescription() {
      if (this.isForResetDetermination) return 'regresar';

      if (
        this.determinationStatusId ===
        proposalRequestStatus.RequirementsDoesNotAccomplish
      )
        return 'marcar como No Cumple Requisitos';

      return this.determinationStatusId === proposalRequestStatus.Recommended
        ? 'recomendar'
        : this.determinationStatusId ===
          proposalRequestStatus.PartialRecommendation
        ? 'recomendar parcialmente'
        : 'NO recomendar';
    },
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onSaveHandler() {
      const isFormValid = await this.$refs.determinationFormRef.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      let modalDescription = `¿Está seguro(a) que desea ${
        this.actionDescription
      } la ${
        this.isForResetDetermination ? 'determinación de la' : ''
      } propuesta ${this.proposalRequestNumber}?`;

      const answer = await this.ShowCancelModal(
        'Confirmación',
        modalDescription,
        'Sí',
        'No'
      );
      if (!answer) return;

      if (this.isForResetDetermination)
        await this.saveResetRequestDetermination();
      else await this.saveRequestDetermination();
    },
    async saveRequestDetermination() {
      const payload = {
        proposalRequestId: this.proposalRequestId,
        determinationStatusId: this.determinationStatusId,
        comment: this.model.comment,
      };

      if (this.determinationStatusId == proposalRequestStatus.Recommended) {
        const { data } = await checkBusySsn(this.proposalRequestId);

        if (data) {
          this.ShowAlertModal(
            'Actualización de Proponente',
            'Se encontró que el Proponente a Recomendar es uno existente por lo que se procederá actualizar la información de su perfil.'
          );
        }
      }

      const { data } = await _determineProposalRequest(payload).catch(
        (error) => {
          this.ShowToast('Alerta', `${error.response.data.message}.`, 'error');
          return { data: false };
        }
      );

      let confirmationMessage =
        'La propuesta ha sido determinada exitosamente.';
      switch (this.determinationStatusId) {
        case proposalRequestStatus.RequirementsDoesNotAccomplish:
          confirmationMessage =
            'La propuesta ha sido determinada como no cumple con los requisitos exitosamente';
          break;
        case proposalRequestStatus.PartialRecommendation:
          confirmationMessage =
            'La propuesta ha sido recomendada de forma parcial exitosamente.';
          break;
        case proposalRequestStatus.Recommended:
          confirmationMessage =
            'La propuesta ha sido recomendada exitosamente.';
          break;
        case proposalRequestStatus.NotRecommended:
          confirmationMessage =
            'La propuesta no ha sido recomendada exitosamente.';
          break;
      }

      if (data) {
        this.ShowToast('Confirmación', confirmationMessage, 'success');
        this.$emit('saved');
      }
    },
    async saveResetRequestDetermination() {
      const payload = {
        proposalRequestId: this.proposalRequestId,
        comment: this.model.comment,
      };
      const { data } = await _resetDeterminationProposalRequest(payload).catch(
        (error) => {
          this.ShowToast('Alerta', `${error.response.data.message}.`, 'error');
          return { data: false };
        }
      );
      if (data) {
        this.ShowToast(
          'Confirmación',
          'La determinación ha sido reiniciada exitosamente.',
          'success'
        );
        this.$emit('saved');
      }
    },
  },
};
</script>
